const PUBLIC_PATHS = [
    '/home',
    '/tenant-home',
    '/details',
    '/privacy-policy',
    '/terms-and-conditions',
];

/** The public website around the portal: landing pages, articles and legal pages. */
export const isPublicPath = (pathname: string): boolean => {
    if (PUBLIC_PATHS.includes(pathname)) return true;
    if (pathname.startsWith('/articles/')) return true;
    return false;
};
